import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";

export function NotFoundPage() {
  const {
    getRoutes
  } = useContext(AppContext);

  const ROUTE_CONFIG = getRoutes();

  return (
    <>
      <Helmet>
        <title>{ ROUTE_CONFIG.NOT_FOUND.title }</title>
        <meta name="description" content={ ROUTE_CONFIG.NOT_FOUND.title } />
      </Helmet>
      4 😢 4
    </>
  );
}
